import Box from "@mui/material/Box";

type MaxWidthSizes = "sm" | "md" | "lg" | "xl";

const FormContainer = ({
  maxWidth = "md",
  children,
}: {
  maxWidth?: MaxWidthSizes;
  children: React.ReactNode;
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        // Stretch the container to the full size
        alignSelf: "stretch",
        maxWidth: toMaxWidth(maxWidth),
      }}
    >
      {children}
    </Box>
  );
};

const toMaxWidth = (maxWidth: MaxWidthSizes) => {
  switch (maxWidth) {
    case "sm":
      return "12rem";
    case "md":
      return "20rem";
    case "lg":
      return "32rem";
    case "xl":
      return "48rem";
  }
};

export default FormContainer;
